import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, ModalClose } from '@mui/joy';
import { DetailTitle, InfoHeader, Button, useDrawer } from 'src/mtska-frontend-app-component';
import AudienceSegmentCreator from '../AudienceSegmentCreator';
import { Alert } from '@mui/material';
import { useDataProvider } from 'src/mtska-frontend-data-provider';

const dataProviderName = 'audiences/audiencesegment';
const model = 'audiences/audienceSegment';
const wizardAction = 'create';

const Create = (params) => {
    const { t } = useTranslation();
    const [actionInvoked, setActionInvoked] = useState(0);
    const [errorMessage, setErrorMessage] = useState(null);
    const [forwardDisabled, setForwardDisabled] = useState(false);
    const [backDisabled, setBackDisabled] = useState(true);
    const [actionLabel, setActionLabel] = useState(t('Next'));
    const [isCompleted, setIsCompleted] = useState(false);

    const { close } = useDrawer();
    const { doAction, item, errorMessage: dpErrorMessage, saving, success } = useDataProvider(dataProviderName, params.multipart);

    useEffect(() => {
        if (success && item) {
            const performClose = async () => {
                try {
                    if (params.handleClose) {
                        await params.handleClose(params.uid, item.data);
                    } else {
                        close();
                    }
                } catch (e) {
                    console.error('Error during drawer close:', e);
                }
            };
            performClose();
        }
    }, [success, item, params.handleClose, params.uid, close]);

    const handleSave = async (data) => {
        try {
            await doAction({
                action: wizardAction,
                model: model ? model : dataProviderName,
                data: data
            });
        } catch (error) {
            const saveError = error.message || t('An error occurred while saving.');
            setErrorMessage(saveError);
            throw new Error(saveError);
        }
    };

    useEffect(() => {
        if (success) {
            setIsCompleted(true);
        }
    }, [success]);

    return (
        <>
            {params.isDrawer && (
                <Box className="drawer-section-header">
                    <ModalClose onClick={() => close()} />
                    <DetailTitle title={t('Create a new segment')} icon="faFile" />
                    <Box display="flex" flexDirection="row" justifyContent="end" gap={1} flexGrow={1}>
                        {!isCompleted && (
                            <>
                                <Button label={t('Back')} onClick={() => setActionInvoked(-1)} disabled={backDisabled || saving} />
                                <Button
                                    label={actionLabel}
                                    onClick={() => setActionInvoked(1)}
                                    disabled={forwardDisabled || saving}
                                    loading={saving}
                                />
                            </>
                        )}
                        {isCompleted && (
                            <Button label={t('Close')} onClick={() => close()} />
                        )}
                    </Box>
                </Box>
            )}
            {params.isDrawer && <Box className="breadcrumb" sx={{ height: 24, bgcolor: 'transparent' }} />}
            <>
                {(errorMessage || dpErrorMessage) && (
                    <Alert severity="error">{errorMessage || dpErrorMessage}</Alert>
                )}
                <Box className="drawer-section-content">
                    <InfoHeader view="wizard" title={t('Create audience segment')} subtitle={t('Description new segment creation')} />
                    <AudienceSegmentCreator
                        {...params}
                        onSave={handleSave}
                        externalSetForwardDisabled={setForwardDisabled}
                        externalSetBackDisabled={setBackDisabled}
                        externalSetActionInvoked={setActionInvoked}
                        externalSetActionLabel={setActionLabel}
                        externalSetErrorMessage={setErrorMessage}
                        actionInvoked={actionInvoked}
                        isCompleted={isCompleted}
                    />
                </Box>
            </>
        </>
    );
};

export default Create;